import React from "react";
import styled from "styled-components";
// import ScrollTrigger from 'react-scroll-trigger';
import "./animations.css";
import { InView } from "react-intersection-observer";
import Testimonialsection from "./Testimonialsection";
import Breadcrumbs from "../components/Breadcrumbs";
import HeaderContainer from "../components/HeaderContainer";
import {
  EduServiceIcon,
  GuidanceServiceIcon,
  PaymentServiceIcon,
  ScholarshipAppServiceIcon,
  UniAppServiceIcon,
  VisaAppServiceIcon,
} from "../components/icon";

const ServicesContainer = styled.div`
  margin: 115px auto 32px;
  width: 100%;
`;

const ServicesGrid = styled.div`
  padding: 0 4rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 40px;
  @media screen and (max-width: 768px) {
    padding: 0 1rem;
    grid-template-columns: 1fr;
  }
`;

const ServiceCard = styled.div`
  border: 1px solid #d9d9d9;
  padding: 24px;
  border-radius: 22px;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 24px;

  @media screen and (min-width: 1180px) {
    text-align: left;
  }
`;

const ServiceImage = styled.img`
  max-width: 100%;
  width: 300px;
  height: auto;
  margin-bottom: 2rem;
`;

const ServiceTitle = styled.h2`
  font-weight: 600;
  font-size: 26px;
  color: #000;

  @media (max-width: 768px) {
    font-size: 18px;
    font-weight: 700;
  }
`;
const ServiceDescription = styled.p`
  font-size: 1rem;
  color: #666;
  text-align: center;
  line-height: 1.5rem;

  @media screen and (min-width: 769px) {
    padding: 0 2rem;
  }

  @media screen and (max-width: 1180px) {
    font-size: 0.9rem;
  }
`;

const ServiceContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;

  @media screen and (min-width: 1080px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 3rem;
    margin: 0rem 4rem;
  }
`;

const ServiceRightContainer = styled.div`
  display: none;

  @media screen and (min-width: 1180px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const ServiceImageMobile = styled.img`
  max-width: 100%;
  width: 300px;
  height: auto;
  margin-bottom: 2rem;

  @media screen and (min-width: 1180px) {
    display: none;
  }
`;

const ServiceLeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 1180px) {
    text-align: left;
  }
`;

const LearnMoreButton = styled.a`
  text-decoration: none;
  border: none;
  display: inline-flex;
  background-color: #af3c2c;
  color: #fff;
  padding: 18px 24px;
  border-radius: 76px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 400;

  &:hover {
    background-color: #af3c2ce6;
  }
`;

const services = [
  {
    title: "Education Counseling",
    description:
      "Our team of experienced education counselors provide personalized guidance to help you choose the right course and university based on your interests, goals, and qualifications. We also advise on alternative pathways and recommend suitable institutions, ensuring you make an informed decision about your future studies.",
    link: "/Services/education-counseling",
    image: <EduServiceIcon />,
  },
  {
    title: "Universities Application",
    description:
      "Navigating the application process can be challenging, but our experts are here to help. We guide you through every step of the process, including document preparation, submission, and tracking. We also offer insights and advice on personal statements, essays, and interviews, ensuring you maximize your chances of success.",
    link: "/Services/application-process",
    image: <UniAppServiceIcon />,
  },
  {
    title: "Visa Application ",
    description:
      "Applying for a visa can be complex, but our comprehensive visa guidance ensures a smooth process. We provide advice on the necessary documentation and requirements, help you fill out the application forms accurately, and offer insights on common pitfalls and how to avoid them, giving you the confidence to navigate the visa application process.",
    link: "/Services/visa-application",
    image: <VisaAppServiceIcon />,
  },
  {
    title: "Scholarship Application",
    description:
      "Funding your international education can be a challenge, but our team is here to help. We assist you in identifying and applying for scholarships, grants, and financial aid opportunities that are relevant to your chosen course and institution. Our guidance can help ease the financial burden of your studies and enable you to focus on achieving your academic goals.",
    link: "/Services/scholarship-application",
    image: <ScholarshipAppServiceIcon />,
  },
  {
    title: "Predeparture and Departure Guidance",
    description:
      "Embarking on your international education journey can be both exciting and daunting. Our predeparture and departure guidance ensures you are fully prepared for your adventure. We provide advice on packing, accommodation, travel arrangements, and cultural adjustment, as well as tips for navigating any challenges you may encounter during your studies abroad.",
    link: "/Services/predeparture-guidance",
    image: <GuidanceServiceIcon />,
  },
  {
    title: "Payment",
    description:
      "Our currency exchange company offer competitive rates and secure payment solutions for your international education fees. We provide guidance on the most cost-effective methods to transfer funds and help you navigate the complexities of international transactions. By taking advantage of our currency exchange services, you can minimize fees and maximize the value of your investment in your education abroad.",
    link: "/services/payment",
    image: <PaymentServiceIcon />,
  },
];

const ServicesPage = () => {
  return (
    <ServicesContainer>
      <HeaderContainer
        title={"Our Services"}
        content={"Expert Guidance for Your International Education Journey"}
      />
      <Breadcrumbs variant="two" />
      <ServicesGrid>
        {services.map((service, index) => (
          <InView key={service?.title} triggerOnce threshold={0.1}>
            {({ inView, ref }) => (
              <ServiceCard
                ref={ref}
                index={index}
                className={inView ? "fade-in-up" : ""}
              >
                {service.image}
                <ServiceTitle>{service.title}</ServiceTitle>
                <ServiceDescription>{service.description}</ServiceDescription>
                <LearnMoreButton href={service.link}>
                  Learn More
                </LearnMoreButton>
              </ServiceCard>
            )}
          </InView>
        ))}
      </ServicesGrid>
      <Testimonialsection />
    </ServicesContainer>
  );
};
export {
  ServicesContainer,
  ServicesGrid,
  ServiceCard,
  ServiceImageMobile,
  ServiceContentContainer,
  ServiceRightContainer,
  ServiceImage,
  ServiceLeftContainer,
  ServiceTitle,
  ServiceDescription,
};

export default ServicesPage;
